<template>
  <div class="view--select-work-center">
    <CreateWorkcenter @update="getWorkcenters" class="create-work-center mr-3" ref="createWorkcenter"
      v-if="this.isAdmin" />
    <EditWorkCenter @update="getWorkcenters" :editMode="true" class="create-work-center" ref="editWorkcenter"
      v-if="this.isAdmin" />
    <!-- Ir a fichajes-->
    <v-btn v-if="this.user && this.user.worker" :dark="$getPrimaryButton('dark')" depressed class="ml-3"
      :rounded="$getPrimaryButton('rounded')" :outlined="false" :color="$getPrimaryButton('color')" right
      @click="goToCargaHoras">
      <v-icon left>mdi-calendar</v-icon>Ir a carga de horas
    </v-btn>
    <!-- loading -->
    <HeaderFilter @updateParent="updateFilter" @tableView="setTableView" icon="people" ref="headerFilter" />
    <v-progress-linear class="mt-5" v-if="loading" :color="$getColor('vuetifyColor1')" :indeterminate="loading">
    </v-progress-linear>
    <div v-else>
      <v-tabs v-model="activeTab" class="mb-5">
        <v-tab><v-icon left>mdi-office-building</v-icon>Centros de Trabajo</v-tab>
        <v-tab><v-icon left>mdi-chart-box-outline</v-icon>Estadísticas Globales</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab" style="background: transparent;">
        <v-tab-item>
          <div v-show="tableView">
            <v-expand-transition>
              <v-data-table :headers="responsiveHeaders" :items="filteredOptions" :items-per-page="10"
                class="elevation-1" calculate-widths :color="$getColor('vuetifyColor1')" outlined flat elevation="1"
                full-width :mobile-breakpoint="0" show-expand :footer-props="{
                  showFirstLastPage: true,
                  'items-per-page-text': 'Elementos por página',

                }">
                <template v-slot:[`item.avatar`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon class="mr-1" :dark="$getPrimaryButton('dark')" depressed
                        :rounded="$getPrimaryButton('rounded')" :outlined="$getPrimaryButton('outlined')"
                        :color="$getPrimaryButton('color')" @click="updateWorkcenter(item, 'AdminCalendar')"
                        v-bind="attrs" v-on="on">
                        <v-icon>mdi-calendar</v-icon>
                      </v-btn>
                    </template>
                    <span>Ir a Cuadrantes</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.text`]="{ item }">
                  <span class="font-weight-medium">{{ item.text }}</span>
                </template>
                <template v-slot:[`item.totalWorkers`]="{ item }">
                  <v-avatar color="success" size="35"><span class="white--text">{{ item.totalWorkers
                      }}</span></v-avatar>
                </template>
                <template v-slot:[`item.config`]="{ item }">
                  <v-icon medium v-if="item.availableSchedule"
                    :color="$getColor('vuetifyColor2')">mdi-calendar-check</v-icon>
                  <v-icon medium v-if="item.availableClockEntries"
                    :color="$getColor('vuetifyColor2')">mdi-clock-check</v-icon>
                  <v-icon medium v-if="item.availableN3" :color="$getColor('vuetifyColor2')">mdi-currency-eur</v-icon>
                </template>

                <template v-slot:[`item.totalIncidences`]="{ item }">
                  <v-avatar v-if="item.totalIncidences > 0" color="primary" size="35"><span class="white--text">{{
                    item.totalIncidences }}</span></v-avatar>
                  <v-avatar v-else color="grey" size="35"><span class="white--text">{{ item.totalIncidences
                      }}</span></v-avatar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-col>
                    <v-row class="flex-nowrap">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon small class="mr-4" :dark="$getPrimaryButton('dark')" depressed
                            :rounded="$getPrimaryButton('rounded')" :outlined="$getPrimaryButton('outlined')"
                            :color="$getPrimaryButton('color')" @click="updateWorkcenter(item, 'Home')" v-bind="attrs"
                            v-on="on">
                            <v-icon>mdi-home</v-icon>
                          </v-btn>
                        </template>
                        <span>Ir al panel de inicio del centro de trabajo</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small icon :dark="$getPrimaryButton('dark')" :rounded="$getPrimaryButton('rounded')"
                            :outlined="$getPrimaryButton('outlined')" :color="$getPrimaryButton('color')"
                            @click="editWorkcenter(item)" v-bind="attrs" v-on="on" depressed>
                            <v-icon>mdi-square-edit-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar centro de trabajo</span>
                      </v-tooltip>
                    </v-row>
                  </v-col>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-list dense v-if="isMobile" class="mb-2">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Descripción</v-list-item-subtitle>
                          <v-list-item-title>{{ item.description || '-' }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Incidencias</v-list-item-subtitle>
                          <v-list-item-title>
                            <v-avatar v-if="item.totalIncidences > 0" color="primary" size="25"><span
                                class="white--text caption">{{ item.totalIncidences }}</span></v-avatar>
                            <span v-else>0</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Trabajadores</v-list-item-subtitle>
                          <v-list-item-title>
                            <v-avatar color="success" size="25"><span class="white--text caption">{{ item.totalWorkers
                                }}</span></v-avatar>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Configuración</v-list-item-subtitle>
                          <v-list-item-title>
                            <v-icon small v-if="item.availableSchedule"
                              :color="$getColor('vuetifyColor2')">mdi-calendar-check</v-icon>
                            <v-icon small v-if="item.availableClockEntries"
                              :color="$getColor('vuetifyColor2')">mdi-clock-check</v-icon>
                            <v-icon small v-if="item.availableN3"
                              :color="$getColor('vuetifyColor2')">mdi-currency-eur</v-icon>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </td>
                </template>
              </v-data-table>
            </v-expand-transition>
          </div>
          <div class="select-work-center--grid" v-show="!tableView">

            <mdtec-panel v-for="option in filteredOptions" :key="option.value" class="work-center--item">
              <template v-slot:title>
                <!--
          <v-icon>mdi-office-building</v-icon>
          -->
                <span class="work-center--item__title">{{ option.text }}
                </span>

              </template>
              <template v-slot:content>
                <div class="work-center--item__description">
                  "{{ option.description }}"
                </div>
                <div class="work-center--item--insights">
                  <div class="work-center--item--insights__group">
                    <div class="work-center--item--insights__group__icon">
                      <v-icon>mdi-account-group</v-icon>
                    </div>
                    <div class="work-center--item--insights__group__value">
                      {{ option.totalWorkers }}
                      Empleados/as
                    </div>
                  </div>
                  <div class="work-center--item--insights__group">
                    <div class="work-center--item--insights__group__icon">
                      <v-icon color="primary">mdi-alert-circle</v-icon>
                    </div>
                    <div class="work-center--item--insights__group__value" style="color: var(--color1) !important;">
                      {{ option.totalIncidences }}
                    </div>
                  </div>
                  <!-- wc availability -->
                  <div>
                    <v-col>
                      <v-row>
                        <div class="work-center--item--insights__group" v-if="option.availableSchedule">
                          <div class="work-center--item--insights__group__icon">
                            <v-icon medium color="success">mdi-calendar-check</v-icon>
                          </div>
                        </div>
                        <div class="work-center--item--insights__group" v-if="option.availableClockEntries">
                          <div class="work-center--item--insights__group__icon">
                            <v-icon medium color="success">mdi-clock-check</v-icon>
                          </div>
                        </div>
                        <div class="work-center--item--insights__group" v-if="option.availableN3">
                          <div class="work-center--item--insights__group__icon">
                            <v-icon medium color="success">mdi-currency-eur</v-icon>
                          </div>
                        </div>
                      </v-row>
                    </v-col>
                  </div>
                </div>
                <div class="work-center--item__edition">
                  <v-btn depressed class="mr-auto" :dark="$getPrimaryButton('dark')" small
                    :rounded="$getPrimaryButton('rounded')" :outlined="true" color="grey"
                    @click="editWorkcenter(option)">
                    <v-icon left>mdi-square-edit-outline</v-icon>Editar
                  </v-btn>
                </div>
              </template>
              <template v-slot:footerActions>
                <v-row justify="space-around">
                  <v-btn outlined :color="$getColor('vuetifyColor1')"
                    @click="updateWorkcenter(option, 'Home')">Seleccionar</v-btn>
                  <v-btn dark :color="$getColor('vuetifyColor1')" @click="updateWorkcenter(option, 'AdminCalendar')">
                    <v-icon left>mdi-calendar</v-icon>Cuadrantes
                  </v-btn>
                </v-row>
              </template>
            </mdtec-panel>
            <mdtec-panel class="work-center--add-center" isInteractive @click.native="addWorkCenter()"
              v-if="this.$store.getters['auth/hasRole'](['ROLE_SUPER_ADMIN'])">
              <template v-slot:content>

                <div class="work-center--add-center__icon">
                  <v-icon color="primary" size="64">mdi-plus</v-icon>
                </div>
                <div class="work-center--add-center__text">
                  <span style="color: var(--color1) !important;">
                    Añadir centro de trabajo
                  </span>
                </div>
              </template>
            </mdtec-panel>
          </div>
        </v-tab-item>

        <v-tab-item>
          <v-row class="mt-4">
            <!-- Left Column: KPIs -->
            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12" sm="6" lg="6">
                  <v-card class="elevation-1 pa-4 rounded-lg d-flex align-center h-100">
                    <v-icon x-large color="primary" class="mr-4">mdi-office-building</v-icon>
                    <div>
                      <div class="text-subtitle-1 grey--text text--darken-1">Centros Totales</div>
                      <div class="text-h4 font-weight-bold">{{ totalWorkcenters }}</div>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" lg="6">
                  <v-card class="elevation-1 pa-4 rounded-lg d-flex align-center h-100">
                    <v-icon x-large color="success" class="mr-4">mdi-calendar-check</v-icon>
                    <div>
                      <div class="text-subtitle-1 grey--text text--darken-1">Cuadrantes Habilitados</div>
                      <div class="text-h4 font-weight-bold">{{ totalScheduledCenters }}</div>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" lg="6">
                  <v-card class="elevation-1 pa-4 rounded-lg d-flex align-center h-100">
                    <v-icon x-large color="success" class="mr-4">mdi-clock-check</v-icon>
                    <div>
                      <div class="text-subtitle-1 grey--text text--darken-1">Fichajes Habilitados</div>
                      <div class="text-h4 font-weight-bold">{{ totalClockCenters }}</div>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" lg="6">
                  <v-card class="elevation-1 pa-4 rounded-lg d-flex align-center h-100">
                    <v-icon x-large color="info" class="mr-4">mdi-account-group</v-icon>
                    <div>
                      <div class="text-subtitle-1 grey--text text--darken-1">Trabajadores Totales</div>
                      <div class="text-h4 font-weight-bold">{{ combinedTotalWorkers }}</div>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" lg="12">
                  <v-card class="elevation-1 pa-4 rounded-lg d-flex align-center h-100">
                    <v-icon x-large color="error" class="mr-4">mdi-alert-circle</v-icon>
                    <div>
                      <div class="text-subtitle-1 grey--text text--darken-1">Incidencias Globales</div>
                      <div class="text-h4 font-weight-bold error--text">{{ combinedTotalIncidences }}</div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>

            <!-- Right Column: Chart -->
            <v-col cols="12" md="6">
              <v-card class="elevation-1 pa-4 rounded-lg text-center h-100" style="padding-bottom: 30px;">
                <h3 class="text-h6 font-weight-regular primary--text mb-4">Trabajadores por Centro</h3>
                <div style="height: 300px; display: flex; align-items: center; justify-content: center;">
                  <WorkcenterChart ref="workcenterChart" style="width: 100%; height: 100%;" />
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import workcenterService from '@/services/workcenter.service';
import scheduleService from '@/services/schedule.service';
import CreateWorkcenter from '@/views/_FATDA/components/CreateWorkCenter.vue';
import EditWorkCenter from '@/views/_FATDA/components/EditWorkCenter.vue';
import MdtecPanel from '@/components/Cards/MdtecPanel.vue';
import authService from '@/services/auth.service';
import HeaderFilter from '@/components/Filter/WorkcenterHeaderFilter.vue';
import WorkcenterChart from '@/components/Charts/WorkcenterChart.vue';

export default {
  name: 'select-workcenter',
  components: {
    CreateWorkcenter,
    MdtecPanel,
    HeaderFilter,
    EditWorkCenter,
    WorkcenterChart,
  },
  data: () => ({
    project: null,
    options: [],
    sourceOptions: [],
    info: null,
    loading: true,
    errored: false,
    userId: null,
    userRole: null,
    userName: null,
    user: null,
    admins: [],

    filter: null,

    isAdmin: false,
    tableView: false,
    activeTab: 0,

    headers: [
      {
        text: '',
        align: 'start',
        sortable: false,
        value: 'avatar',
      },
      {
        text: 'Nombre',
        align: 'start',
        sortable: true,
        value: 'text',
      },
      { text: '', value: 'config', width: '110px' },
      { text: 'Descripción', value: 'description' },
      { text: 'Incidencias', value: 'totalIncidences' },
      { text: 'Trabajadores', value: 'totalWorkers' },
      {
        text: 'Acciones', value: 'actions', sortable: false, width: '110px',
      },
    ],
  }),

  created() {
    this.isAdmin = this.$store.getters['auth/hasRole'](['ROLE_SUPER_ADMIN']);
  },

  mounted() {
    this.user = authService.getDecodedJwtToken(this.$store.state.auth.user);

    this.getWorkcenters();
  },

  watch: {
    options: {
      handler() {
        if (this.$refs.workcenterChart) {
          this.$refs.workcenterChart.updateChartData(this.options);
        }
      },
      deep: true,
    },
    activeTab(newVal) {
      if (newVal === 1) { // "Estadísticas Globales" Tab index
        this.$nextTick(() => {
          if (this.$refs.workcenterChart) {
            this.$refs.workcenterChart.updateChartData(this.options);
          }
        });
      }
    },
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 960;
    },
    responsiveHeaders() {
      if (this.isMobile) {
        return this.headers.filter((h) => h.value === 'avatar' || h.value === 'text' || h.value === 'actions' || h.value === 'data-table-expand');
      }
      return this.headers;
    },
    filteredOptions() {
      if (this.options.length <= 0 || !this.filter.name) {
        return this.options;
      }
      return this.options.filter((option) => option.text.toLowerCase().includes(this.filter.name.toLowerCase()));
    },
    totalWorkcenters() {
      return this.options ? this.options.length : 0;
    },
    totalScheduledCenters() {
      return this.options ? this.options.filter((w) => w.availableSchedule).length : 0;
    },
    totalClockCenters() {
      return this.options ? this.options.filter((w) => w.availableClockEntries).length : 0;
    },
    unconfiguredCenters() {
      return this.options ? this.options.filter((w) => !w.availableClockEntries && !w.availableSchedule).length : 0;
    },
    combinedTotalWorkers() {
      return this.options ? this.options.reduce((sum, w) => sum + (w.totalWorkers || 0), 0) : 0;
    },
    combinedTotalIncidences() {
      return this.options ? this.options.reduce((sum, w) => sum + (w.totalIncidences || 0), 0) : 0;
    },
  },

  methods: {
    updateFilter(val) {
      this.filter = val;
      this.loading = false;
    },
    setTableView(val) {
      this.tableView = val;
    },
    updateWorkcenter(val, route) {
      this.project = val;
      console.log('Selected workcenter:', this.project);
      this.$store.commit('setProject', val);
      this.$router.push({ name: route });
    },
    editWorkcenter(workcenter) {
      this.$refs.editWorkcenter.openDialog();
      this.$refs.editWorkcenter.updateWorkCenterData(workcenter);
    },
    getWorkcenters() {
      this.loading = true;
      workcenterService.getAllWorkcenters().then((response) => {
        this.sourceOptions = response.content.map((ele) => ({
          value: ele.id,
          text: ele.name,
          description: ele.description,
          typeId: ele.workcenterType,
          creationTime: new Date(ele.creationTime).toLocaleDateString(),
          icon: 'business_center',
          color: '#424242',
          totalWorkers: 0,
          totalIncidences: 0,
          availableClockEntries: ele.availableClockEntries,
          availableSchedule: ele.availableSchedule,
          availableN3: ele.availableN3,
        }));
        this.options = this.sourceOptions;
        this.getWorkcentersWorkers();
        this.getWorkcentersIncidences();
      });
    },
    getWorkcentersWorkers() {
      // for each workcenter, get the workers
      this.options.forEach((workcenter) => {
        const params = {
          workCenter: workcenter.value,
        };
        workcenterService
          .getWorkers(params)
          .then((response) => {
            // eslint-disable-next-line no-param-reassign
            workcenter.totalWorkers = response.totalElements;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    getWorkcentersIncidences() {
      this.options.forEach((workcenter) => {
        scheduleService
          .countUnsolvedIncidencesByWorkCenter(workcenter.value)
          .then((response) => {
            // eslint-disable-next-line no-param-reassign
            workcenter.totalIncidences = response;
          });
      });
    },
    addWorkCenter() {
      this.$refs.createWorkcenter.openDialog();
    },
    goToCargaHoras() {
      this.$router.push({ name: 'ConfigureTime' });
    },
  },
};
</script>
<style lang="scss" scoped>
.view--select-work-center {
  .select-work-center--grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: calc(var(--base) * 2);
    margin-top: calc(var(--base) * 2);

    @media (min-width: 1024px) {
      justify-content: flex-start;
    }

    .work-center--item {
      width: 100%;
      min-height: calc(100vw - var(--base) * 4);
      max-height: calc(100vw - var(--base) * 4);

      @media (max-width: 1024px) {
        min-width: 300px;
        min-height: auto;
      }

      @media (min-width: 1024px) {
        min-width: 300px;
        min-height: 300px;
        max-width: 340px;
        max-height: 340px;
      }

      .work-center--item__description {
        font-size: calc(var(--base) * 1.45);
        margin: calc(var(--base) * 1) 0;
        font-style: italic;
      }

      .work-center--item__edition {
        font-size: calc(var(--base) * 1.45);
        margin: calc(var(--base) * 0.1) 0;
      }

      .work-center--item__title {
        font-size: calc(var(--base) * 2.25);
        margin-bottom: calc(var(--base) * 1);
      }

      .work-center--item--admins {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        margin-top: auto;

        &__label {
          font-size: calc(var(--base) * 2.25);
          margin-bottom: calc(var(--base) * 1);
        }

        &__list {
          display: flex;
          flex-wrap: wrap;
          gap: calc(var(--base) * 0.5);
        }
      }

      .work-center--item--insights {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: calc(var(--base) * 1);

        .work-center--item--insights__group {
          display: flex;
          align-items: center;
          gap: calc(var(--base) * 0.5);

          &__icon {
            font-size: calc(var(--base) * 2.25);
          }

          &__value {
            font-size: calc(var(--base) * 2.25);
          }
        }
      }
    }

    .work-center--add-center {
      width: calc(100vw - var(--base) * 4);
      min-height: calc(100vw - var(--base) * 4);
      max-height: calc(100vw - var(--base) * 4);

      @media (min-width: 1024px) {
        min-width: 300px;
        min-height: 300px;
        max-width: 340px;
        max-height: 340px;
      }

      &:hover {
        background: rgba(var(--bodyCorporate), 0.1);

        .work-center--add-center__icon {
          transform: scale(1.2);
        }
      }

      .mdtec-card--content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .work-center--add-center__icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          transition: all ease-out 0.3s;
        }

        .work-center--add-center__text {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;

          span {
            text-align: center;
            font-size: calc(var(--base) * 1.75);
            max-width: 80%;
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 1.25px;
          }
        }
      }
    }
  }

  .avatar-text {
    font-size: calc(var(--base) * 1.75);
    text-transform: uppercase;
    text-align: center;
  }
}
</style>
<style lang="scss">
.view--select-work-center {
  & .work-center--add-center {
    & .mdtec-card--content {
      height: 100% !important;
      justify-content: space-between;
    }
  }

  & .work-center--item {
    &.mdtec-card {
      justify-content: space-between;

      @media (max-width: 1024px) {
        padding: calc(var(--base) * 2);
      }
    }

    & .mdtec-card--content {
      height: 100% !important;
      gap: calc(var(--base) * 2);
    }

    & .mdtec-card--footer {
      &__actions {
        width: 100%;
      }

      height: auto !important;
      align-items: center;
    }
  }
}
</style>
